<template>
	<v-progress-linear
		:color="color"
		:value="value"
		:buffer-value="max"
		:indeterminate="indeterminate"
	/>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: 'primary',
		},
		indeterminate: Boolean,
		value: [Number, String],
		max: {
			type: [Number, String],
			default: 100,
		},
	},
}
</script>
